// Keep frequently used Element Plus styles in one shared entry so Vite emits
// one CSS request instead of many small render-blocking stylesheets.
import "element-plus/es/components/checkbox/style/index.mjs";
import "element-plus/es/components/empty/style/index.mjs";
import "element-plus/es/components/input/style/index.mjs";
import "element-plus/es/components/loading/style/index.mjs";
import "element-plus/es/components/message/style/index.mjs";
import "element-plus/es/components/message-box/style/index.mjs";
import "element-plus/es/components/notification/style/index.mjs";
import "element-plus/es/components/pagination/style/index.mjs";
import "element-plus/es/components/rate/style/index.mjs";
import "element-plus/es/components/select/style/index.mjs";
import "element-plus/es/components/skeleton/style/index.mjs";
import "element-plus/es/components/text/style/index.mjs";
import "element-plus/es/components/tree-v2/style/index.mjs";

export default defineNuxtPlugin(() => {});
